import { useEffect } from 'react';
import { useAccessLevelContext } from '../context/access-level-context';
import axios, { endpoints } from 'src/utils/axios';
import { getRole } from '../context/jwt/utils';
import { useAuthContext } from './use-auth-context';

export default function useFetchPermissions() {
  const {
    setEntityPermissions,
    setViewPermissions,
    setActionPermissions,
    setLoadingPermissions,
  } = useAccessLevelContext();

  const { authenticated } = useAuthContext();

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const role = getRole();

        const [entityResponse, viewResponse, actionResponse] =
          await Promise.all([
            axios.get(`${endpoints.entityPermissions}/${role}`),
            axios.get(`${endpoints.viewPermissions}/${role}`),
            axios.get(`${endpoints.actionPermissions}/${role}`),
          ]);

        setViewPermissions(viewResponse.data);
        setEntityPermissions(entityResponse.data);
        setActionPermissions(actionResponse.data);
        setLoadingPermissions(false);
      } catch (error) {
        console.error('Error fetching permissions:', error);
      }
    };

    if (authenticated) fetchPermissions();
  }, [
    setEntityPermissions,
    setViewPermissions,
    setActionPermissions,
    setLoadingPermissions,
    authenticated,
  ]);
}
